import { Avatar, Box, Icon, type IColumn, Typography } from 'shared/ui'
import { EmptyCell } from 'shared/ui/TableNew'
import { DayjsFormats, getLabelAsNumberInternationalFormat } from 'shared/lib'
import { uiStore } from 'shared/store/uiStore'
import { type ReviewContactRow } from 'entities/Review'

export const columns: IColumn<ReviewContactRow>[] = [
  {
    field: 'full_name',
    name: 'Name',
    isDisabledChangeVisible: true,
    isSortable: true,
    width: '266px',
    renderRowCell: ({ fullName, avatarInfo }) => (
      <Box display={'flex'} alignItems={'center'} gap={'8px'}>
        <Avatar info={avatarInfo} size={24} />
        {fullName ? (
          <Typography variant={'body-md-regular'} ariaLabel={'ReviewContactName'} ellipsis>
            {fullName}
          </Typography>
        ) : (
          <EmptyCell />
        )}
      </Box>
    ),
  },
  {
    field: 'number',
    name: 'Number',
    width: '129px',
    renderRowCell: ({ formattedNumber }) =>
      formattedNumber ? (
        <Typography variant={'body-md-regular'} ariaLabel={'ReviewContactNumber'}>
          {getLabelAsNumberInternationalFormat(formattedNumber)}
        </Typography>
      ) : (
        <EmptyCell />
      ),
  },
  {
    field: 'rating',
    name: 'Stars',
    width: '80px',
    renderRowCell: ({ rate }) => (
      <Box display={'flex'} alignItems={'center'} gap={'4px'}>
        <Icon icon={'starFilled1'} fontSize={14} color={'var(--yellow-70)'} />
        <Typography variant={'body-md-regular'} ariaLabel={'ReviewContactStars'}>
          {rate}
        </Typography>
      </Box>
    ),
  },
  {
    field: 'feedback',
    name: 'Feedback',
    width: '39%',
    minWidth: 290,
    maxWidth: 435,
    renderRowCell: ({ comment }) =>
      comment ? (
        <Typography variant={'body-md-regular'} ariaLabel={'ReviewContactFeedback'} ellipsis>
          {comment}
        </Typography>
      ) : (
        <EmptyCell />
      ),
  },
  {
    field: 'submitted_at',
    name: 'Submitted at',
    width: '170px',
    renderRowCell: ({ createdAt }) =>
      createdAt ? (
        <Typography variant={'body-md-regular'} ariaLabel={'ReviewContactSubmittedAt'}>
          {uiStore.dayjs(createdAt).format(DayjsFormats.fullWithAtDash)}
        </Typography>
      ) : (
        <EmptyCell />
      ),
  },
]
